// Facebook Pixel Utility
// Pixel ID: 1991066405169739

export const FB_PIXEL_ID = '1991066405169739';

// Track standard events
export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
};

// Track custom events
export const trackCustomEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', eventName, params);
  }
};

// Standard Facebook Pixel Events
export const FacebookEvents = {
  // When someone clicks on a CTA button
  Lead: (params = {}) => trackEvent('Lead', params),
  
  // When someone views content (specific page/section)
  ViewContent: (params = {}) => trackEvent('ViewContent', params),
  
  // When someone initiates contact
  Contact: (params = {}) => trackEvent('Contact', params),
  
  // When someone completes registration
  CompleteRegistration: (params = {}) => trackEvent('CompleteRegistration', params),
  
  // When someone starts checkout/demo request
  InitiateCheckout: (params = {}) => trackEvent('InitiateCheckout', params),
  
  // When someone schedules a demo
  Schedule: (params = {}) => trackEvent('Schedule', params),
};

// Custom Events for SoluClinic
export const SoluClinicEvents = {
  // When user clicks "Agendar Demonstração"
  ClickDemo: () => trackCustomEvent('ClickDemo', {
    content_name: 'Demonstração SoluClinic',
    content_category: 'Demo Request'
  }),
  
  // When user clicks WhatsApp button
  ClickWhatsApp: (plan = 'general') => {
    trackEvent('Contact', {
      content_name: `WhatsApp - ${plan}`,
      content_category: 'WhatsApp Contact'
    });
    trackEvent('Lead', {
      content_name: `Lead - ${plan}`,
      value: plan === 'Enterprise Max' ? 999.99 : plan === 'Enterprise' ? 599.99 : 0,
      currency: 'BRL'
    });
  },
  
  // When user views pricing section
  ViewPricing: () => trackEvent('ViewContent', {
    content_name: 'Pricing Section',
    content_category: 'Pricing'
  }),
  
  // When user scrolls to specific section
  ViewSection: (sectionName) => trackEvent('ViewContent', {
    content_name: sectionName,
    content_category: 'Page Section'
  }),
  
  // When user clicks on a specific plan
  SelectPlan: (planName, price) => {
    trackEvent('InitiateCheckout', {
      content_name: planName,
      value: price,
      currency: 'BRL'
    });
  }
};

export default FacebookEvents;
